export const SET_SCENARIO_LEVELS = "SET_SCENARIO_LEVELS";
export const SET_SCENARIO_LAYER_ID = "SET_SCENARIO_LAYER_ID";
export const UPDATE_SCENARIOS_NOTE = "UPDATE_SCENARIOS_NOTE";
